module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selectOneOrMore":"Select one or more","ok":"OK"},"zh-tw":{"selectOneOrMore":"多選","ok":"確定"}}')
  delete Component.options._Ctor
}
